import { ConfigurationManager } from "../ConfigurationManager";
import { Slot, SLOT_TYPES } from "./Slot";
export var BOOKING_STATUS;
(function (BOOKING_STATUS) {
    BOOKING_STATUS["draft"] = "draft";
    BOOKING_STATUS["planned"] = "planned";
    BOOKING_STATUS["aborted"] = "aborted";
    BOOKING_STATUS["finished"] = "finished";
    BOOKING_STATUS["canceled"] = "canceled";
    BOOKING_STATUS["rejected"] = "rejected";
    BOOKING_STATUS["requested"] = "requested";
    BOOKING_STATUS["live"] = "live";
    BOOKING_STATUS["paused"] = "paused";
})(BOOKING_STATUS || (BOOKING_STATUS = {}));
;
const PRELIVE_STATUS = [
    BOOKING_STATUS.draft, BOOKING_STATUS.requested, BOOKING_STATUS.canceled, BOOKING_STATUS.rejected
];
export class BookingBaseData {
    id;
    name;
    /**
     * @Todo add advertiser instead of any
     */
    advertiser;
    /**
     * @Todo add brand instead of any
     */
    brand;
    slotId;
    start;
    end;
    volumeTotal;
    status;
    constructor(data = null) {
        if (data) {
            for (let key in data) {
                this[key] = data[key];
            }
        }
    }
    isActive() {
        return [BOOKING_STATUS.live, BOOKING_STATUS.planned].indexOf(this.status) >= 0;
    }
    isCanceled() {
        return [BOOKING_STATUS.aborted, BOOKING_STATUS.canceled, BOOKING_STATUS.rejected].indexOf(this.status) >= 0;
    }
    isFinished() {
        return [BOOKING_STATUS.finished].indexOf(this.status) >= 0;
    }
}
export class BookingRequestData extends BookingBaseData {
    /**
     * A list of candidates for review
     */
    assetCandidates;
}
export class BookingRequest extends BookingRequestData {
    constructor(data = null) {
        super();
        if (data) {
            for (let key in data) {
                this[key] = data[key];
            }
        }
    }
    get slot() {
        return ConfigurationManager.getInstance().gamesController.getSlot(this.slotId);
    }
}
export class BookingData extends BookingBaseData {
    volumeSpent;
    assets;
}
export class BookingAsset {
    url;
    id;
    selected;
    refSlot;
    get slot() {
        return ConfigurationManager.getInstance().gamesController.getSlot(this.refSlot);
    }
}
export class Booking extends BookingData {
    _slot;
    constructor(data = null) {
        super();
        if (data) {
            for (let key in data) {
                this[key] = data[key];
            }
            if (!this.volumeSpent) {
                this.volumeSpent = 0;
            }
        }
    }
    get slot() {
        let p = ConfigurationManager.getInstance().gamesController.getSlot(this.slotId);
        p.then((s) => {
            this._slot = s;
        });
        return p;
    }
    tryGetSlot() {
        return this._slot;
    }
    get earnings() {
        return ConfigurationManager.getInstance().statsController.getTotalEarningForBooking(this.id);
    }
    isPreLive() {
        return PRELIVE_STATUS.indexOf(this.status) >= 0;
    }
    isOwner(user) {
        return user.getCompanyId() == this.advertiser || user.isAdmin();
    }
}
